import { WM_ENVIRONMENT } from "./config";

//stage
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  apiURL: WM_ENVIRONMENT === 'development' ? "https://swisehandler.wisemonkeys.info/" : 'https://wisehandler.wisemonkeys.info/',
  redirectURL: WM_ENVIRONMENT === 'development' ? 'https://stage.wisemonkeys.info' : 'https://wisemonkeys.info',
  publicURL: WM_ENVIRONMENT === 'development' ? 'https://stage.wisemonkeys.info' : 'https://wisemonkeys.info',
  identity: 'wmhandler',
  test : WM_ENVIRONMENT === 'development' ? '' : ''
};

// //production
// export default {
//   apiURL: "https://wisehandler.wisemonkeys.info/",
//   redirectURL: 'https://wisemonkeys.info',
//   publicURL: 'https://wisemonkeys.info',
//   identity: 'wmhandler',
// };